import React, { useState, useEffect } from 'react'
import { Form, Alert, InputGroup, Spinner } from 'react-bootstrap'
import { ReportResponseForm } from '../../components/kyc/ReportResponseForm'
import '../../components/kyc/kycStyle.css'
import ScreenHeader from '../../components/kyc/ScreenHeader'
import { validateIdNumber } from '../../utils/Validation'
import KycButton from '../../components/form/Button/Button'
import FormInput from '../../components/form/FormInput/FormInput'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import TableDataConsumerTrace from '../../components/ConsumerTrace/TableDataConsumerTrace'
import NewAndCloseButtons from '../../components/form/NewAndCloseButtons/NewAndCloseButtons'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import {
  // downloadReport,
  handleConsumerTraceLoadReport,
  searchConsumer,
} from '../../api/consumerTrace/consumerTrace'
import { ReportTypes } from '../../api/apiConstants'
import {
  INVALID_ID_WARNING,
  RESTRICTED_REPORT,
  DETAILED_BUSINESS_REPORT_OPTIONS,
  CONSUMER_TRACE_OPTIONS,
  CONSUMER_TRACE_SUBHEADING,
  DISCLAIMER,
  PRICELIST,
} from '../../utils/Constants'
import SearchBySelect from '../../components/form/SearchBySelect/SearchBySelect'
import { useMutation } from 'react-query'
import { useDownloadFile } from '../../hooks/use-download-file'
import { ReactDatePicker } from '../../components/kyc/ReactDatePicker'
import moment from 'moment'

enum SearchByTypes {
  ID = 'id',
  CONTACT = 'contact',
  PASSPORT = 'passport',
  PERSONAL = 'personal',
}

enum SearchTypeTypes {
  AGE = 'age',
  BIRTHDATE = 'dob',
}

type ConsumerTraceProps = {
  setShow: React.Dispatch<React.SetStateAction<boolean>>
  setIsError: React.Dispatch<React.SetStateAction<boolean>>
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>
  initialState: { [key: string]: any }
  setInitialState: React.Dispatch<React.SetStateAction<any>>
  KYCAccess: boolean
}

type xpertConsumer = {
  firstname?: string
  surname?: string
  idno?: string
  passportnumber?: string
  name?: string
  enquiryID?: string
  enquiryResultID?: string
}

const ConsumerTrace: React.FC<ConsumerTraceProps> = ({
  setShow,
  setIsError,
  setErrorMessage,
  initialState,
  setInitialState,
  KYCAccess,
}) => {
  const [isDisabled, setIsDisabled] = useState(true)
  const [surname, setSurname] = useState('')
  const [forename, setForename] = useState('')
  const [birthYear, setBirthYear] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [_date, set_Date] = useState<Date | null>(null)
  const [contactNumber, setContactNumber] = useState('')
  const [idNumber, setIdNumber] = useState('')
  const [passportNumber, setPassportNumber] = useState('')
  const [reference, setReference] = useState('')
  const [showProgress, setShowProgress] = useState(false)
  const [xpertConsumer, setXpertConsumer] = useState<xpertConsumer>({})
  const [xpertConsumers, setXpertConsumers] = useState<xpertConsumer[]>([])
  const [reportId, setReportId] = useState('0')
  const [searchBy, setSearchBy] = useState<string>('id')
  const [searchType, setSearchType] = useState<string>('')
  const [prescribedPurposeSelectedOption, setPrescribedPurposeSelectedOption] =
    useState<string>('')

  const handleSetSearchType = (selectedOptionValue: string) => {
    setBirthYear('')
    setDateOfBirth('')
    setSearchType(selectedOptionValue)
  }
  const handleSearchBy = (selectedOptionValue: string) => {
    setReference('')
    setIdNumber('')
    setSurname('')
    setForename('')
    setDateOfBirth('')
    setBirthYear('')
    setPassportNumber('')
    setSearchBy(selectedOptionValue)
  }
  const handleSearchByPrescribedPurpose = (selectedOptionValue: string) => {
    setPrescribedPurposeSelectedOption(selectedOptionValue)
  }

  const handleStartOver = () => {
    setReportId('0')
    setShowProgress(false)
    setReference('')
    setIdNumber('')
    setSurname('')
    setPrescribedPurposeSelectedOption('')
    setIsDisabled(true)
    setXpertConsumer({})
    setXpertConsumers([])
    setSearchBy('id')
  }

  const updateInitialState = () => {
    setInitialState({
      ...initialState,
      consumerTrace: {
        surname: surname,
        idNumber: idNumber,
        passportNumber: passportNumber,
        reference: reference,
        reportId: reportId,
      },
    })
  }

  const { mutate: downloadReport, isLoading: isDownloading } = useDownloadFile(
    '/ConsumerTrace/download-report',
    reportId,
    ReportTypes.ConsumerTraceReport.reportTypeId,
    setIsError,
    setErrorMessage,
  )

  const handleConsumerTraceLoadReportParams = {
    idNumber,
    passportNumber,
    xpertConsumer,
    reference,
    setShowProgress,
    setIsError,
    setErrorMessage,
    setReportId,
    reportTypeId: ReportTypes.ConsumerTraceReport.reportTypeId,
    purpose: prescribedPurposeSelectedOption,
    downloadReport,
  }

  const handleDownloadReport = () => {
    updateInitialState()
    downloadReport(reportId)
  }

  const handleSearch = () => {
    // Set searchType.
    // Refactor this please someone.
    const missingFields = validateForm()
    if (missingFields.length > 0)
      return alert(
        'Please complete the following fields: ' + missingFields.join(', '),
      )
    let searchType
    if (searchBy === SearchByTypes.ID) searchType = 1
    else if (searchBy === SearchByTypes.PASSPORT) searchType = 2
    else if (searchBy === SearchByTypes.CONTACT) searchType = 3
    else if (searchBy === SearchByTypes.PERSONAL) searchType = 4

    const searchConsumerParams = {
      idNumber,
      surname,
      contactNumber,
      forename,
      passportNumber,
      birthYear,
      dateOfBirth: _date ? moment(_date).format('YYYY-MM-DD') : undefined,
      prescribedPurposeSelectedOption,
      reference,
      searchType,
      reportType: 9,
      productId: 2,
      setShowProgress,
      setIsError,
      setErrorMessage,
      setXpertConsumers,
    }
    updateInitialState()
    searchConsumer(searchConsumerParams)
  }
  const validateForm = () => {
    const missingFields = []
    // setIsDisabled(true)
    switch (searchBy) {
      case SearchByTypes.ID:
        if (!validateIdNumber(idNumber)) missingFields.push('ID Number')
        break
      case SearchByTypes.CONTACT:
        if (surname === '') missingFields.push('Surname')
        if (contactNumber === '') missingFields.push('Contact Number')
        break
      case SearchByTypes.PASSPORT:
        if (passportNumber === '') missingFields.push('Passport Number')
        break
      case SearchByTypes.PERSONAL:
        if (surname === '') missingFields.push('Surname')
        if (forename === '') missingFields.push('Forename')
        if (_date === null && birthYear === '')
          missingFields.push('Either Date of Birth or Age')
        break
    }
    if (prescribedPurposeSelectedOption === '')
      missingFields.push('Prescribed Purpose')
    return missingFields
  }

  const SurnameInput = () => {
    return (
      <FormInput
        labelText="Surname"
        placeHolderText="Enter surname"
        onChangeHandler={setSurname}
        value={surname}
      />
    )
  }

  const handleOnRowClick = (xpertConsumer: xpertConsumer) => {
    const props = {
      ...handleConsumerTraceLoadReportParams,
      xpertConsumer,
    }
    handleConsumerTraceLoadReport(props)
  }

  useEffect(() => {
    if (Object.keys(xpertConsumer).length > 0)
      handleConsumerTraceLoadReport(handleConsumerTraceLoadReportParams)
  }, [xpertConsumer])

  useEffect(() => {
    if (searchBy === SearchByTypes.PERSONAL) setSearchType(SearchTypeTypes.AGE)
  }, [searchBy])

  return (
    <ScreenLayout
      price={PRICELIST.CONSUMER_TRACE}
      headerText="Consumer Trace"
      subHeaderText={CONSUMER_TRACE_SUBHEADING}
      sampleReport={'ConsumerTrace.pdf'}
    >
      {showProgress && (
        <>
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        </>
      )}
      {Object.keys(xpertConsumers).length === 0 && (
        <Form.Group>
          {KYCAccess !== true && <p className="lbl-red">{RESTRICTED_REPORT}</p>}
          <SearchBySelect
            className="mb-3"
            required
            onChangeHandler={(selectedOptionValue: string) =>
              handleSearchBy(selectedOptionValue)
            }
            options={[
              { value: '', label: '- Search By -' },
              { value: SearchByTypes.ID, label: 'ID Number' },
              { value: SearchByTypes.PASSPORT, label: 'Passport Number' },
              { value: SearchByTypes.PERSONAL, label: 'Personal Details' },
            ]}
          />
          {searchBy === SearchByTypes.ID && (
            <>
              <FormInput
                required
                className="mb-3"
                placeHolderText="Unique identity number"
                onChangeHandler={setIdNumber}
                value={idNumber}
              />
              {idNumber !== '' && !validateIdNumber(idNumber) ? (
                <Alert variant="danger" transition={false}>
                  {INVALID_ID_WARNING}
                </Alert>
              ) : null}
            </>
          )}
          {searchBy === SearchByTypes.PERSONAL && (
            <>
              <FormInput
                className="mb-3"
                placeHolderText="Enter surname"
                onChangeHandler={setSurname}
                value={surname}
              />
            </>
          )}
          {searchBy === SearchByTypes.CONTACT && (
            <>
              <FormInput
                className="mb-3"
                placeHolderText="Enter surname"
                onChangeHandler={setSurname}
                value={surname}
              />
              <FormInput
                className="mb-3"
                placeHolderText="Contact Number"
                onChangeHandler={setContactNumber}
                value={contactNumber}
              />
            </>
          )}
          {searchBy === SearchByTypes.PASSPORT && (
            <>
              <FormInput
                className="mb-3"
                placeHolderText="Enter passport number"
                onChangeHandler={setPassportNumber}
                value={passportNumber}
              />
            </>
          )}
          {searchBy === SearchByTypes.PERSONAL && (
            <>
              <FormInput
                className="mb-3"
                placeHolderText="Enter first name"
                onChangeHandler={setForename}
                value={forename}
              />
              <SearchBySelect
                className="mb-3"
                required
                onChangeHandler={(selectedOptionValue: string) =>
                  handleSetSearchType(selectedOptionValue)
                }
                options={[
                  { value: '', label: '- Search Type - ' },
                  { value: SearchTypeTypes.AGE, label: 'Age' },
                  {
                    value: SearchTypeTypes.BIRTHDATE,
                    label: 'Date of birth',
                  },
                ]}
              />
              {searchType === SearchTypeTypes.AGE && (
                <>
                  <FormInput
                    className="mb-3"
                    placeHolderText="Enter age"
                    onChangeHandler={setBirthYear}
                    value={birthYear}
                  />
                </>
              )}
              {searchType === SearchTypeTypes.BIRTHDATE && (
                <>
                  <InputGroup
                    style={{ width: '100%', maxWidth: '430px', zIndex: 10 }}
                    className="mb-3"
                  >
                    <ReactDatePicker
                      selected={_date}
                      onChange={(date: Date) => set_Date(date)}
                      placeholderText="CCYY-MM-DD"
                    />
                  </InputGroup>
                  {/* <FormInput
                    className="mb-3"
                    placeHolderText="CCYY-MM-DD"
                    onChangeHandler={setDateOfBirth}
                    value={dateOfBirth}
                  /> */}
                </>
              )}
            </>
          )}
          <SearchBySelect
            className="mb-3"
            onChangeHandler={(selectedOptionValue: string) =>
              handleSearchByPrescribedPurpose(selectedOptionValue)
            }
            options={DETAILED_BUSINESS_REPORT_OPTIONS.PrescribedPurpose}
            required
          />
          <FormInput
            className="mb-3"
            placeHolderText="Search reference (optional)"
            onChangeHandler={setReference}
            value={reference}
          />
          <FooterButtons setShow={setShow} handleSearch={handleSearch} />
          <p className="disclaimer">{DISCLAIMER}</p>
        </Form.Group>
      )}
      {Object.keys(xpertConsumers).length > 0 && (
        <>
          <TableDataConsumerTrace
            // showProgress={showProgress || isDownloading}
            xpertConsumers={xpertConsumers}
            setXpertConsumer={handleOnRowClick}
          />
          <NewAndCloseButtons
            handleAction={handleStartOver}
            handleClose={setShow}
          />
        </>
      )}
      {/* {parseInt(reportId) > 0 && (
        <>
          <div>
            <KycButton
              onClick={handleDownloadReport}
              variant={'primary'}
              children={'Download Report'}
              isLoading={isDownloading}
              size="lg"
            />
          </div>
          <NewAndCloseButtons
            handleAction={handleStartOver}
            handleClose={setShow}
          />
        </>
      )} */}
    </ScreenLayout>
  )
}
export default ConsumerTrace
